"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toArray = void 0;
var toArray = function (property) {
    if (!property &&
        (property !== false && property !== 0))
        return []; //return an empty array if the property is falsy. ( except for an explicity 'false' or '0' value )
    if (property.constructor === Array)
        return property;
    //else
    return [property];
};
exports.toArray = toArray;
